import { getContext, setContext } from "svelte"
import type { Readable } from "svelte/store"
import type { AdminSession } from "@kontextwerk/control-web-client"

import type { PermissionState } from "../permissions-model"

export type KehrblattControlAuthContext = {
  session: AdminSession | null
  user: AdminSession["user"] | null
  permissions: PermissionState
  currentUserId: string | null
  currentUserRole: string | null
  currentUserOrganizationId: string | null
}

const kehrblattControlAuthContextKey = Symbol("kehrblatt-control-auth-context")

export const setKehrblattControlAuthContext = (
  store: Readable<KehrblattControlAuthContext | null>,
) => {
  setContext(kehrblattControlAuthContextKey, store)

  return store
}

export const getKehrblattControlAuthContext = () =>
  getContext<Readable<KehrblattControlAuthContext | null>>(kehrblattControlAuthContextKey)
